import { z } from "zod";
import { baseURL } from "../utils/base-url";
import { axiosInstance } from "..";
import { NetworxResponse } from "../utils/types";
import { getAuthHeaders } from "../utils/headers";
import { serializeQueryParams } from "@/utils/network";

export async function getCheckProsPartners(input: ParamsCheckProsPartners) {
  const queryParams = serializeQueryParams(input);
  console.log("getCheckProsPartners::before");
  const response = await axiosInstance.get<NetworxResponse<unknown, ResponseGetCheckProsPartners>>(
    `/homeowner/check_pros_partners?${queryParams}`,
    {
      baseURL: baseURL.homeowner_v2,
      headers: getAuthHeaders(),
      meta: {
        disableToasts: true,
      }
    });

  console.log("getCheckProsPartners::response", { data: response.data })
  return response.data;
}

export const getCheckProsPartnersSchema = z.object({
  zip: z.string(),
  service: z.number(),
  question: z.record(z.string(), z.string()),
  n_phone: z.string().optional(),
  email: z.string().optional(),
})

export type ParamsCheckProsPartners = z.infer<typeof getCheckProsPartnersSchema>;

type Pro = { id: string; name: string; };
export type ResponseGetCheckProsPartners = {
  pros: Pro[];
  tcpa_text: string;
  is_partner: boolean;
  stay_on_platform: boolean;
  redirect_to_thumbtack: boolean;
  /** only used for Mixpanel tracking */
  nx_task: string;
  /** only used for Mixpanel tracking */
  tt_pros: unknown[];
  /** only used for Mixpanel tracking */
  tt_task: string | null;
}
